const updateQueryString = (queryString: string) => {
  window.history.replaceState('', '', queryString);
};

export default updateQueryString;
